import { render, staticRenderFns } from "./DashboardEvents.vue?vue&type=template&id=0a95d7e0&"
import script from "./DashboardEvents.vue?vue&type=script&lang=js&"
export * from "./DashboardEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports